import { getUserRoles } from '../utils/roleHelpers';

export function teacherMustChooseGroup(user) {
  const roles = getUserRoles(user);
  if (roles.includes('owner') || roles.includes('admin') || roles.includes('secretary')) return false;
  return roles.includes('teacher');
}

export function groupsForTeacher(groups, userId) {
  return (groups || []).filter((group) => String(group.teacher_id) === String(userId));
}

export function eventsForGroup(events, group) {
  const active = (events || []).filter((event) => event.is_active !== false);
  if (!group) return active;
  return active.filter((event) => String(event.discipline_id) === String(group.discipline_id));
}

export function groupsForDiscipline(groups, disciplineId) {
  if (!disciplineId) return groups || [];
  return (groups || []).filter((group) => String(group.discipline_id) === String(disciplineId));
}

export function formAfterGroupChange(form, group, events) {
  const event = (events || []).find((item) => String(item.id) === String(form.eventId));
  const eventFits = !group || !event || String(event.discipline_id) === String(group.discipline_id);
  return {
    ...form,
    groupId: group ? String(group.id) : '',
    studentId: '',
    eventId: eventFits ? form.eventId : '',
    time: eventFits ? form.time : '',
  };
}

export function studentsInGroup(students, enrollments) {
  const ids = new Set((enrollments || []).map((row) => String(row.student_id)));
  return (students || []).filter((student) => ids.has(String(student.id)));
}

export function buildMarkPayload({ studentId, eventId, groupId, timeMs, attempts, isScore }) {
  const payload = {
    student_id: Number(studentId),
    event_id: Number(eventId),
    time_ms: isScore ? 0 : timeMs,
    group_id: groupId ? Number(groupId) : null,
  };
  if (isScore) payload.details = { attempts };
  return payload;
}
